import type { ReactNode } from 'react';
import { cn } from '@helpers/cn';

interface TableItemCardProps {
  main: ReactNode;
  onClick?: () => void;
  title: ReactNode;
  titleAction?: ReactNode;
}

const TableItemCard = ({
  main,
  onClick,
  title,
  titleAction,
}: TableItemCardProps) => {
  const content = (
    <div className='eye:overflow-hidden eye:rounded-md eye:border eye:border-grey-20 eye:bg-white'>
      <div
        className={cn(
          'eye:px-2xs eye:py-4xs eye:body-m-highlight eye:text-left eye:bg-blue-25 eye:group-has-data-[title-highlighted=true]/table-item-card:bg-yellow-35',
          { 'eye:pr-m': !!titleAction },
        )}
      >
        {title}
      </div>

      <div className='eye:w-full eye:p-2xs'>{main}</div>
    </div>
  );

  return (
    <div className='eye:group/table-item-card eye:relative eye:w-full'>
      {onClick ? (
        <button
          type='button'
          onClick={onClick}
          className='eye:w-full eye:cursor-pointer eye:rounded-md eye:focus-visible:outline-2 eye:hover:outline-2 eye:outline-black eye:outline-offset-3'
        >
          {content}
        </button>
      ) : (
        content
      )}
      {titleAction ? (
        <div className='eye:pointer-events-none eye:absolute eye:inset-x-0 eye:top-0 eye:z-10 eye:flex eye:items-center eye:justify-end eye:px-2xs eye:py-4xs'>
          <div className='eye:pointer-events-auto'>{titleAction}</div>
        </div>
      ) : null}
    </div>
  );
};

export default TableItemCard;
